import Api from "../../utils/api";
import Endpoints from "../../core/config/Endpoints";

export class ProductService {

    async add(data) {
        const token = localStorage.getItem("token");
        if (!token) {
            return null;
        }
        const response = await Api.post(Endpoints.product, data, {
            "Content-Type": "application/json",
            Authorization: token,
        });

        return response ?? null;
    }

    async get(id) {
        const token = localStorage.getItem("token");
        if (!token) {
            return null;
        }
        const response = await Api.get(`${Endpoints.product}/${id}`, {
            "Content-Type": "application/json",
            Authorization: token,
        });

        return response ?? null;
    }
    async all() {
        const token = localStorage.getItem("token");
        if (!token) {
            return null;
        }
        const response = await Api.get(Endpoints.allProducts, {
            "Content-Type": "application/json",
            Authorization: token,
        });

        return response ?? null;
    }

    async update(id, data) {
        const token = localStorage.getItem("token");
        if (!token) {
            return null;
        }
        const response = await Api.patch(`${Endpoints.product}/${id}`, data, {
            "Content-Type": "application/json",
            Authorization: token,
        });

        return response ?? null;
    }
}
